<template>
  <div id="pager" class="container mt-5">
    <div class="row">
      <article class="offset-xl-1 col-xl-10 offset-xxl-2 col-xxl-8">
        <nav class="clearfix py-3">
          <span class="float-left" v-if="previous">
            <i class="gel-icon-angle-left text-muted"></i>&nbsp;<router-link :to="{ name: previous.routeName }" class="text-muted">{{ previous.title }}</router-link>
          </span>
          <span class="float-right" v-if="next">
            <router-link :to="{ name: next.routeName }" class="text-muted">{{ next.title }}</router-link>&nbsp;<i class="gel-icon-angle-right text-muted"></i>
          </span>
        </nav>
      </article>
    </div>
  </div>        
</template>

<script>
export default {
  name: "Pager",
  mounted: function () {
    this.expandMenu()
  },
  computed: {
    previous: function () {
      let currentPageMeta = this.$store.state.menu.menuItemsMeta[this.$route.name]
      let currentPageIndex = currentPageMeta.index
      let previousPageRouteName = this.$store.state.menu.menuItems[currentPageIndex - 1]
      if (previousPageRouteName) {
        let previousPageMeta = this.$store.state.menu.menuItemsMeta[previousPageRouteName]
        let previousPageTitle = previousPageMeta.title
        return {
          routeName: previousPageRouteName,
          title: previousPageTitle
        }
      }
      return null
    },
    next: function () {
      this.expandMenu()
      let currentPageMeta = this.$store.state.menu.menuItemsMeta[this.$route.name]
      let currentPageIndex = currentPageMeta.index
      let nextPageRouteName = this.$store.state.menu.menuItems[currentPageIndex + 1]
      if (nextPageRouteName) {
        let nextPageMeta = this.$store.state.menu.menuItemsMeta[nextPageRouteName]
        let nextPageTitle = nextPageMeta.title
        return {
          routeName: nextPageRouteName,
          title: nextPageTitle
        }
      }
      return null
    }
  },
  methods: {
    expandMenu: function () {
      let elements_with_route_link_class = document.getElementsByClassName("router-link-exact-active")
      if (elements_with_route_link_class.length > 0) {
        // Get second route element with active class because logo and introduction submenu link share the same route
        let router_anchor = (elements_with_route_link_class.length > 1) ? elements_with_route_link_class[1] : elements_with_route_link_class[0];
        // Active submenu link's parent
        if (router_anchor) {
          let route_link_parent_ul = router_anchor.parentElement.parentElement
          if (route_link_parent_ul) {
            route_link_parent_ul.classList.add("show")
            let submenu_anchor = route_link_parent_ul.parentElement.children[0]
            if (submenu_anchor) {
              submenu_anchor.classList.remove("collapsed")
            }
          }
        }
      }
    }
  }
};
</script>